export const userDetailsModel = ({
    approvalStatus,
    askToUpdatePassword,
    districtId,
    email,
    firstName,
    isActive,
    lastName,
    organization,
    patronRole = ``,
    patronSubType = ``,
    userId
}: Record<string, any> = {}) => ({

    approvalStatus: approvalStatus?.toString() ?? ``,
    askToUpdatePassword: !!askToUpdatePassword,
    confirmPassword: "",
    districtId,
    email,
    confirmEmail: ``,
    firstName,
    isActive,
    jobTitle: patronRole?.toString() ?? ``,
    lastName,
    organization,
    password: "",
    patronRole,
    patronSubType: patronSubType?.toString() ?? ``,
    updatePassword: false,
    userId,
    floridaShippingConfirmed: "",
});